'use client'
import { cn } from '@qr-front/ui/utils'
import { URL_MAX_LENGTH } from 'constants/validationConstants'
import { qrTypeAtom } from 'features/generator/generatorState'
import { QR_TYPE } from 'features/generator/generatorTypes'
import { useAtomValue } from 'jotai'
import { atomWithReset } from 'jotai/utils'
import { useTranslations } from 'next-intl'
import { useFormContext } from 'react-hook-form'
import { maxLength } from 'utils/inputChangeUtils'

import { RhcField } from '../../../components/RhcField'
import { EmailFields } from './EmailFields'
import { PhoneFields } from './PhoneFields'

export const contactInfoWebsiteAtom = atomWithReset<string | undefined>('')

interface ContactSectionProps {
	phonePath: string
	websitePath: string
	emailPath: string
	websiteAtom: typeof contactInfoWebsiteAtom
	fieldGroup?: string
}

export const ContactSection = ({
	phonePath,
	websitePath,
	emailPath,
	websiteAtom,
	fieldGroup,
}: ContactSectionProps) => {
	const t = useTranslations()
	const form = useFormContext()
	const qrType = useAtomValue(qrTypeAtom)
	const isBusinessPageQrType = QR_TYPE.BusinessPage === qrType

	return (
		<div
			className={cn(
				'grid grid-cols-2 gap-y-4',
				isBusinessPageQrType ? 'gap-x-12' : 'gap-x-8',
			)}
		>
			<PhoneFields path={phonePath} fieldGroup={fieldGroup} />
			<RhcField
				type="url"
				form={form}
				path={websitePath}
				atom={websiteAtom}
				fieldName="website"
				fieldGroup={fieldGroup}
				label={t(
					'generator__content_form_section__about__contact_section__website',
				)}
				placeholder={
					isBusinessPageQrType
						? t(
								'generator__content_form_section__social__input__url_placeholder',
							)
						: t('ui__input_placeholders__url')
				}
				className="col-span-2"
				onChangeTransform={(event) =>
					maxLength(URL_MAX_LENGTH + 1)(event)
				}
			/>
			<EmailFields path={emailPath} />
		</div>
	)
}
